import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import { DONATION_CATEGORY_DETAIL_QUERY } from "../../Queries";
import Presenter from "./Presenter";

export default withRouter(({ history, match, location }) => {
  const { data, loading } = useQuery(DONATION_CATEGORY_DETAIL_QUERY, {
    variables: { id: match.params.id }
  });

  if (!loading && data && data.AdminDonationCategoryDetail) {
    const {
      AdminDonationCategoryDetail: { id, pcIcon, mobileIcon, name }
    } = data;
    return (
      <Presenter
        history={history}
        match={match}
        location={location}
        id={id}
        pcIcon={pcIcon}
        mobileIcon={mobileIcon}
        name={name}
      ></Presenter>
    );
  } else {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  }
});
